import React from 'react';
import { TasticProps } from '../../types';

interface Page {
  page: unknown;
}
interface PageData {
  dataSourceId: string;
  dataSource: {
    results: Page;
  };
}

const CMSPage = ({ data }: TasticProps<{ page: PageData }>) => {
  console.log(data);
  if (!data?.page?.dataSource?.results) return null;

  const page = data?.page?.dataSource?.results?.page || [];

  return <div>{JSON.stringify(page)}</div>;
};

export default CMSPage;
